<template>
  <div class="page">
    <StaticHeader v-bind:title="$root.t('profile:title')"/>
    <div class="container container-nopaddinghorizontal container-afterheader container-includestaticfooter">
      <transition name="container-overlay">
        <div class="container-overlay" v-if="searching"></div>      
      </transition>      

      <div class="container container-small container-float">
        <div class="container-column container-column-left" v-html="$root.t('profile:column_left')"></div>
        <div class="container-column container-column-right" v-html="$root.t('profile:column_right')"></div>
      </div>

     <form v-on:submit.prevent="submit()">
        <div class="container page-submitarea" :class="{'page-submitarea-fixed': $root.isScrolledMore}">
          <div class="container container-small">
            <input class="wide wide-left wide-third" type="submit" :value="$root.t('profile:submit')">
            <router-link tag="input" class="wide wide-middle wide-third" type="submit" :to="`/Person/${$root.logindata.userid}`" :value="$root.t('profile:openprofile')"></router-link>
            <input class="wide wide-right wide-third" type="submit" v-on:click.prevent="close()" :value="$root.t('profile:close')">
          </div>
        </div>
        <div class="container container-small page-fields" v-if="form_data">
          <div class="statecontainer" :class="`statecontainer statecontainer-${data.Contribution.Status}`">
            <input type="submit" v-on:click.prevent="toggleState(data.Contribution.Status)" :value="$root.t(`profile:changevisibility:${data.Contribution.Status}`)">
            <p v-html="$root.t(`profile:visibility:${data.Contribution.Status}`)"></p>
          </div>  
          <ProfileFormField v-bind:values="form_data" v-bind:data="form_field" v-bind:form_data.sync="form_data"/>
        </div>
      </form>
    </div>
    <StaticFooter/>
  </div>
</template>

<style lang="scss">
  @import "../main";
  .statecontainer {
    border: 1px solid;
    width: 100%;
    padding: 1em;
    border-radius: 3px;
    margin-bottom: 1em;
    &-Close {
      border-color: #0F0;
      background-color: rgba(#0F0, 0.1);
    }
    &-Draft {
      border-color: #F00;
      background-color: rgba(#F00, 0.1);
    }
    & > input {
      float: right;
      vertical-align: middle;
      height: 2em;
      padding: 0em 1em !important;
      text-align: center;
      width: auto !important;
      background: #FFF;
      border-color: #000;
      color: #000;
    }
    & > p {
      display: inline-block;
      vertical-align: middle;
      margin: 0;
      line-height: 2em;
      max-width: 60%;
    }
  }
  .page {
      &-content {
          & > h1 {
              margin-top: $base-size * 2;
          }
          & > div {
              max-width: 660px;
              hyphens: auto;
              text-align: justify;
          }
      }
  }

</style>

<script>

import ProfileFormField from '@/components/ProfileFormField.vue'
import StaticHeader from '@/components/StaticHeader.vue'
import StaticFooter from '@/components/StaticFooter.vue'


export default {
  name: 'profile',
  components: {
      StaticHeader,
      StaticFooter,
      ProfileFormField
  },
  data() {
    return {
        data: null,
        searching: true,
        form_data: false,
        form_field: [
          {id: 'name',            name: 'profile:label:name', type: 'text', value: ''},
          {id: 'vorname',         name: 'profile:label:vorname', type: 'text', value: ''},
          {id: 'pseudonym',       name: 'profile:label:pseudonym', type: 'array', value: ['']},
          {id: 'strasse',         name: 'profile:label:strasse', type: 'text', value: ''},
          {id: 'plz',             name: 'profile:label:plz', type: 'text', value: ''},
          {id: 'ort',             name: 'profile:label:ort', type: 'text', value: ''},
          {id: 'kanton',          name: 'profile:label:kanton', type: 'select', value: this.$root.categories.kanton},
          {id: 'land',            name: 'profile:label:land', type: 'select', value: this.$root.categories.land},
          {id: 'literarischesprache',    name: 'profile:label:literarische_sprache', type: 'select_multiple', value: this.$root.categories.languages_parsed},
          {id: 'geburtsdatum',    name: 'profile:label:geburtsdatum', type: 'date', value: ''},
          {id: 'geburtsort',      name: 'profile:label:geburtsort', type: 'text', value: ''},
          {id: 'email',           name: 'profile:label:email', type: 'text', value: ''},
          {id: 'internet',        name: 'profile:label:internet', type: 'array', value: [this.$root.t('profile:label:internet:link'), this.$root.t('profile:label:internet:description')]},
          {id: 'bio',             name: 'profile:label:bio', type: 'textarea', value: '', infotext: 'profile:info:bio'},
          {id: 'foto',            name: 'profile:label:foto', type: 'file', value: '', infotext: 'profile:info:foto'},
          {id: 'angebote',        name: 'profile:label:angebote', type: 'select_multiple', value: this.$root.categories.services_parsed, infotext: 'profile:info:angebote'},
          {id: 'quellsprache',    name: 'profile:label:translator:quellsprache', type: 'select_multiple', value: this.$root.categories.languages_parsed},
          {id: 'zielsprache',     name: 'profile:label:translator:zielsprache', type: 'select_multiple', value: this.$root.categories.languages_parsed},
          {id: 'gndid',           name: 'profile:label:gnd', type: 'gnd', value: []},
          {id: 'socialmedia',     name: 'profile:label:socialmedia', type: 'hash', value: ['Facebook','Twitter','Instagram']},
          {id: 'integration',     name: 'profile:label:integration', type: 'integration', value: this.$root.categories.integration_parsed, infotext: 'profile:info:integration'},
        //{id: 'bemerkungen',     name: 'profile:label:notes', type: 'textarea', value: ''},
        //{id: 'helveticatid',    name: 'profile:label:helveticat', type: 'text', value: ''}
        ]
    }
  },
  mounted() {
    if (!this.$root.logindata.token) {
      this.$root.loginmodal(this.fetchData);
    } else {
      this.fetchData()
    }
  },
  watch: {
    '$route' () {
        this.fetchData(); 
    }
  },
  methods: {
    async fetchData() {
      this.data = await this.$store.dispatch('load', {realtime: true, mode: `/contribution/${this.$root.logindata.userid}`});
      this.form_data = this.data.Data;


      this.form_field.forEach((f)=>{
        this.form_data[f.id] = this.form_data[f.id] || {};
        if (f.type=='select' || f.type=='select_multiple' || f.type=='array') {
          if (typeof this.form_data[f.id].Content === "string") {
            this.form_data[f.id].Content = [this.form_data[f.id].Content];
          }
          this.form_data[f.id].Content = this.form_data[f.id].Content || [];
          
        }
        if (f.type=='hash') {
          this.hashCompare(f, this.form_data[f.id])
        }
        if (f.type=='integration') {
          this.integrationCompare(f, this.form_data[f.id])
        }
        if (f.type=='date') {
          this.form_data[f.id].Content = this.form_data[f.id].Content || 0;
          this.form_data[`${f.id}_genauigkeit`] = this.form_data[`${f.id}_genauigkeit`] || {};
          this.form_data[`${f.id}_genauigkeit`].Content = this.form_data[`${f.id}_genauigkeit`].Content || [0];
          let d = new Date(this.form_data[f.id].Content * 1000);
          if (this.form_data[`${f.id}_genauigkeit`].Content[0] == 0)
            this.form_data[f.id].Content = `${d.getDate()}.${d.getMonth()+1}.${d.getFullYear()}`;
          else if (this.form_data[`${f.id}_genauigkeit`].Content[0] == 1)
            this.form_data[f.id].Content = d.getFullYear();
          else
            this.form_data[f.id].Content = "";
        }
        if (f.type=='file') {
          if (!(this.form_data[f.id].Content && this.form_data[f.id].Content[0] && this.form_data[f.id].Content[0].Captions)) {
            this.form_data[f.id].Content = [{Captions:""}]
          }
        }
      })
      this.searching = false;
    },
    integrationCompare(field, content) {
      let _comp = [];
      content.Content = content.Content || [];
      field.value.forEach((c)=>{
        let _found = false;
        let label = c.Contribution.Id
        content.Content.forEach((row)=>{
          if (row[1] == label) {
            _comp.push([row[0],row[1]]);
            _found = true;
          }
        })
        if (!_found) {
          _comp.push([null,label]);
        }
      })
      content.Content = _comp;
    },
    hashCompare(field, content) {
      let _comp = [];
      content.Content = content.Content || [];
      field.value.forEach((label)=>{
        let _found = false;
        content.Content.forEach((row)=>{
          if (row[1] == label) {
            _comp.push([row[0],row[1]]);
            _found = true;
          }
        })
        if (!_found) {
          _comp.push([null,label]);
        }
      })
      content.Content = _comp;
    },
    async toggleState(state) {
      this.searching = true;
      let result = await this.$store.dispatch('post', {
          mode: `/state/${this.$root.logindata.userid}`, 
          params: {state: state, contribution: this.$root.logindata.userid}
      });
      await this.fetchData(); 
      this.searching = false;
    },
    async submit() {
      this.searching = true;

      var fd = new FormData();
      if (this.form_data.foto.fileElement) {
        fd.append('attachment', this.form_data.foto.fileElement)
      }
      fd.append('data', JSON.stringify(this.form_data));
      let result = await this.$store.dispatch('post', {
          mode: `/profile/${this.$root.logindata.userid}`, 
          params: fd,
          headers: {
            'content-type': 'multipart/form-data'
          }
      });
      if (this.form_data.foto && this.form_data.foto.htmlElement) {
        this.form_data.foto.htmlElement.value = "";
        this.fetchData(); 
      }
      this.searching = false;

    },
    close() {
      this.$router.push('/');
    }
  }
}
</script>
